<template>
  <v-navigation-drawer
    v-model="value"
    class="nav-drawer"
    id="nav-drawer"
    right
    width="752px"
    height="auto"
    fixed
    temporary
    @input="onClickOutDrawer"
  >
    <v-list-item class="nav-header">
      <v-list-item-content>
        <v-list-item-title><slot name="cart_title"></slot></v-list-item-title>
        <v-btn icon @click.stop="foldDrawer(false)">
          <v-icon size="34px">mdi-chevron-right</v-icon>
        </v-btn>
        <p class="text-md-left">
          <slot name="cart_description"></slot>
        </p>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="getBasketCount() > 0">
      <v-list-item-content>
        <div class="checkout-btn-container">
          <v-btn depressed centered class="primary-btn">
            <div class="btn-text" @click="handleCheckOut()"><slot name="cart_btn_txt"></slot></div>
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <div>{{returnArrayOfBasketItemsss()}}</div>
    <v-virtual-scroll :items="returnArrayOfBasketItems()" :item-height="140" class="virtual-scroll">
      <template v-slot="{ item }">
        <v-list nav class="nav-body">
          <div class="nav-flex">
            <v-list-item class="nav-item" :key="item.index" link>
              <v-img
                @click="clickCartItemInDrawer(item.productID)"
                contain
                class="nav-tile"
                :src="item.productData.img"
              ></v-img>
              <v-list-item-content @click="clickCartItemInDrawer(item.productID)">
                <v-list-item-title>{{ item.productData.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <!-- UNCOMMENT QTY div class="counter-text">{{ productData.qty }}</div> -->
                <div class="counter-btn__wrap">
                  <v-btn class="counter-btn" small dark depressed @click="removeFromBasket(item.productID)">
                    <v-icon>mdi-close-thick</v-icon>
                  </v-btn>
                </div>
                <!-- UNCOMMENT PRICE
              <div class="counter-text">{{ productData.price }}</div>
                  !--->
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-list>
      </template>
    </v-virtual-scroll>
  </v-navigation-drawer>
</template>

<script>
import { getSEOIDForProduct } from "../../services/MainService"
export default {
  data: () => ({
    visible_state: false,
  }),
  props: {
    value: Boolean,
  },
  methods: {
    foldDrawer(val) {
      this.$emit("input", val)
    },
    onClickOutDrawer(e) {
      if (!e) {
        this.foldDrawer(false)
      }
    },
    getBasketCount() {
      return this.$store.getters.getBasketCount
    },
    returnArrayOfBasketItems() {
      return Object.keys(this.$store.state.basketModule.basket).map((key, index) => {
        return {
          productID: key,
          productData: this.$store.state.basketModule.basket[key],
          index: index,
        }
      })
    },
    returnArrayOfBasketItemsss() {
      console.log(this.returnArrayOfBasketItems(), "returnArrayOfBasketItems")
    },
    clickCartItemInDrawer(productID) {
      console.log(productID)
      var that = this
      var windowReference = window.open()
      getSEOIDForProduct(productID).then(function (seoIDResponse) {
        if (seoIDResponse.success === true) {
          let targetView;
          if (seoIDResponse.data.pageType == "L1"){
            targetView = "categoryOverview";
          }
          else {
            targetView = "categoryDetailView";
          }
          let routeData = that.$router.resolve({
            name: targetView,
            params: { seoID: seoIDResponse.data.seoID },
          })
          windowReference.location = routeData.href
        }
      })
    },
    removeFromBasket(id) {
      const removeFromBasketPayload = {
        productId: id,
        force: true,
      }
      this.$store.commit("removeFromBasket", removeFromBasketPayload)
    },
    handleCheckOut() {
      let routeData
      if(this.$router.history.current.name == 'customer view for partner sani'){
        routeData = this.$router.resolve({
            name: "SelectionPageApp",
            query: { productHeader: true, chainFilter: this.$router.history.current.params.chainName}
          })
      }else{
        routeData = this.$router.resolve({
            name: "SelectionPageApp",
            query: { productHeader: true }
          })
      }
      window.open(routeData.href, "_blank")
    },
  },
  mounted() {},
  updated() {},
}
</script>
